<script setup>
import { ref } from 'vue';
import AppIcon from '@/components/ui/AppIcon.vue';
import { icons } from '@/config/icons';

const visible = ref(true);
</script>

<template>
  <aside v-if="visible" class="mobile-experience-banner" role="status">
    <span>Platform Forms works on mobile, but the form builder is designed for a larger screen.</span>
    <button type="button" aria-label="Dismiss message" @click="visible = false"><AppIcon :icon="icons.close" /></button>
  </aside>
</template>

<style scoped lang="scss">
.mobile-experience-banner {
  display: none;
}

@media (max-width: 766px) {
  .mobile-experience-banner {
    position: relative;
    z-index: 80;
    display: flex;
    min-height: 44px;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid var(--pf-color-border);
    background: var(--pf-color-accent);
    padding: 10px 16px;
    color: var(--pf-color-accent-contrast);
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
  }
  button {
    display: grid;
    min-width: 32px;
    height: 32px;
    cursor: pointer;
    place-items: center;
    border: 1px solid rgb(0 0 0 / 24%);
    background: transparent;
    color: inherit;
  }
}
</style>
